export default "__VITE_ASSET__BDRSrRZA__"